import { render, staticRenderFns } from "./AsideProfile.vue?vue&type=template&id=2a9b8542&scoped=true&"
import script from "./AsideProfile.vue?vue&type=script&lang=js&"
export * from "./AsideProfile.vue?vue&type=script&lang=js&"
import style0 from "./AsideProfile.vue?vue&type=style&index=0&id=2a9b8542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9b8542",
  null
  
)

export default component.exports